import { render, staticRenderFns } from "./HomeSalesReceipts.vue?vue&type=template&id=0ae13245&scoped=true&"
import script from "./HomeSalesReceipts.vue?vue&type=script&lang=js&"
export * from "./HomeSalesReceipts.vue?vue&type=script&lang=js&"
import style0 from "./HomeSalesReceipts.vue?vue&type=style&index=0&id=0ae13245&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae13245",
  null
  
)

export default component.exports